import {
  dateFromUnixTimestamp as h,
  rehydrateDateAfterJsonization as w
} from "../../util/date-utils.js";
import r from "../../../shared-lib/braze-shared-lib.js";
import Yt from "./trigger-condition.js";
import { validateValueIsFromEnum as F } from "../../util/code-utils.js";
export default class pt {
  constructor(t, i, s, e, r, l, o, n, h, a, u, d) {
    (this.id = t),
      (this.pu = i || []),
      void 0 === s && (s = null),
      (this.startTime = s),
      void 0 === e && (e = null),
      (this.endTime = e),
      (this.priority = r || 0),
      (this.type = l),
      (this.Du = n || 0),
      null == a && (a = 1e3 * (this.Du + 30)),
      (this.Vi = a),
      (this.data = o),
      null == h && (h = pt.Pu),
      (this.yu = h),
      (this.ju = u),
      (this.wu = d || null);
  }
  Nu(t) {
    return (
      null == this.wu || (this.yu !== pt.Pu && t - this.wu >= 1e3 * this.yu)
    );
  }
  vu(t) {
    this.wu = t;
  }
  zu(t) {
    const i = t + 1e3 * this.Du;
    return Math.max(i - new Date().valueOf(), 0);
  }
  Iu(t) {
    const i = new Date().valueOf() - t,
      s = null == t || isNaN(i) || null == this.Vi || i < this.Vi;
    return (
      s ||
        r.D.info(
          `Trigger action ${this.type} is no longer eligible for display - fired ${i}ms ago and has a timeout of ${this.Vi}ms.`
        ),
      !s
    );
  }
  static fromJson(t) {
    const i = t.id,
      s = [];
    for (let i = 0; i < t.trigger_condition.length; i++)
      s.push(Yt.fromJson(t.trigger_condition[i]));
    const e = h(t.start_time),
      r = h(t.end_time),
      l = t.priority,
      o = t.type,
      n = t.delay,
      a = t.re_eligibility,
      u = t.timeout,
      d = t.data,
      m = t.min_seconds_since_last_trigger;
    return F(
      pt.Ki,
      o,
      "Could not construct Trigger from server data",
      "Trigger.Types"
    )
      ? new pt(i, s, e, r, l, o, d, n, a, u, m)
      : null;
  }
  ss() {
    const t = [];
    for (let i = 0; i < this.pu.length; i++) t.push(this.pu[i].ss());
    return {
      i: this.id,
      c: t,
      s: this.startTime,
      e: this.endTime,
      p: this.priority,
      t: this.type,
      da: this.data,
      d: this.Du,
      r: this.yu,
      tm: this.Vi,
      ss: this.ju,
      ld: this.wu
    };
  }
  static Pn(t) {
    const i = [];
    for (let s = 0; s < t.c.length; s++) i.push(Yt.Pn(t.c[s]));
    return new pt(
      t.i,
      i,
      w(t.s),
      w(t.e),
      t.p,
      t.t,
      t.da,
      t.d,
      t.r,
      t.tm,
      t.ss,
      t.ld
    );
  }
}
(pt.Pu = -1), (pt.Ki = { Ji: "inapp", $u: "templated_iam" });
